<template>
    <v-container class="pt-1" :class="$vuetify.breakpoint.xs ? 'px-2' : 'px-1'">
        <v-card
            class="elevation-4 soli-round flex"
            style="display: flex; overflow: hidden"
        >
            <v-list-item-avatar
                :size="$vuetify.breakpoint.xs ? 74 : 88"
                class="-blue"
                :class="$vuetify.breakpoint.xs ? 'ml-3 mr-0' : 'ml-5 mr-1'"
                ><v-img src="/grandview-exterior.webp"></v-img
            ></v-list-item-avatar>
            <div class="flex-col align-self-center">
                <v-card-title class="pb-0 text-subtitle-1 text-sm-h6">{{
                    `Welcome${
                        welcomeBack ? " Back" : nothingBooked ? "!" : ""
                    }, ${user.first_name}!`
                }}</v-card-title>

                <v-card-subtitle v-if="getTotalPasses" class="pb-0 pt-3">{{
                    `You have ${getTotalPasses} Drop-In passes left`
                }}</v-card-subtitle>

                <div
                    class="px-3 py-2 flex"
                    :class="$vuetify.breakpoint.xs ? 'flex-col' : null"
                >
                    <SoliBtn
                        v-if="getTotalPasses"
                        :small="$vuetify.breakpoint.width < 375"
                        @click="
                            $emit('bookNow', {
                                type: {
                                    dropIn: true,
                                    name: 'Drop-In',
                                    originalType: 'Drop-In',
                                    disabled: false,
                                    recurring: false,
                                },
                            })
                        "
                        :disabled="disabled"
                        class="ma-1"
                        >Book a Drop-In</SoliBtn
                    >

                    <SoliBtn
                        :small="$vuetify.breakpoint.width < 400"
                        @click="
                            $emit('bookNow', {
                                type: {
                                    name: 'Reschedule',
                                    originalType: 'Weekly Lesson',
                                    recurring: false,
                                    disabled: false,
                                    reschedule: true,
                                },
                            })
                        "
                        :disabled="disabled"
                        class="ma-1"
                        :loading="apiLoading"
                        >Reschedule A Missed Lesson
                    </SoliBtn>
                    <!--<SoliBtn
                        :small="$vuetify.breakpoint.width < 375"
                        @click="
                            $emit('bookNow', {
                                type: {
                                    name: 'Assessment',
                                    originalType: 'Assessment',
                                    recurring: false,
                                    disabled: false,
                                    assessment: true,
                                },
                            })
                        "
                        :disabled="disabled"
                        class="ma-1"
                        >Book An Assessment
                    </SoliBtn>-->
                </div>
                <v-col class="px-4" v-if="nothingBooked">
                    It looks like you have a pass or membership (awesome!), but
                    you have not been added to the calendar. Contact your
                    studio, teacher, or try again shortly!
                </v-col>
                <v-btn
                    @click="$emit('contactStudio')"
                    class="px-4 mb-3 soli-round text-capitalize text-caption text-sm-subtitle-2"
                    plain
                    small
                    color="primary"
                    >Need help? Contact your studio</v-btn
                >
            </div>
        </v-card>
    </v-container>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            default: null,
        },
        hasFutureLessons: {
            type: Boolean,
            default: false,
        },
        hasPastLessons: {
            type: Boolean,
            default: false,
        },
        hasCancelledLessons: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        activeMemberships: {
            type: Array,
            default: () => [],
        },
        sharedSubscriptions: {
            type: Array,
            default: () => [],
        },
        apiLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            bookNow: {},
        };
    },
    computed: {
        getDropIns() {
            return this.sharedSubscriptions.filter((pass) => {
                if (pass.name == "APL Assessment Pass") return;
                if (pass.access?.includes("Drop-In")) return pass;
                /*if (pass.guest_pass && !pass.first_impression && pass.is_event){
                    return pass;
                }*/
            });
        },
        allDropIns() {
            return this.sharedSubscriptions.filter((e) =>
                e.access?.includes("Drop-In")
            );
        },
        getTotalPasses() {
            if (!this.getDropIns.length) return null;
            return this.getDropIns.map((e) => e.passes).reduce((a, b) => a + b);
        },
        welcomeBack() {
            return !!(
                this.activeMemberships?.length || this.allDropIns?.length
            );
        },
        nothingBooked() {
            return (
                this.welcomeBack &&
                !this.hasPastLessons &&
                !this.hasFutureLessons &&
                !this.getTotalPasses
            );
        },
        /**
         * Change this when adding self serve memberships/classes
         */
        hideActions() {
            return !this.hasCancelledLessons && !this.getTotalPasses;
        },
    },
};
</script>

<style></style>
